<template>
  <div class="box ieorgdetail">
    
    <indexHeader></indexHeader>
    <div class="bg">
      <div class="bg-left">
        <img :src="detail.logo">
      </div>
      <div class="bg-right">
          <div class="bg-title">
            <h1>{{detail.title}}</h1>
            <span>{{detail.content}}</span>
          </div>
          <div class="bg-fa">
            <article>
              <span>{{$t('zdy.fhjg')}}</span>
              <em>1 {{detail.currency_name}} = {{detail.price}} {{detail.pay_currency_name}}</em>
            </article>
            <article>
              <span>{{$t('zdy.fhzl')}}</span>
              <em>{{detail.amount}} {{detail.currency_name}}</em>
            </article>
          </div>
          <div class="bg-btm">
            <a :href="detail.link" target="_blank">{{$t('zdy.gw')}}</a>
            <a :href="detail.white_book" target="_blank">{{$t('zdy.bps')}}</a>
          </div>
      </div>
    </div>
      <div class="tab-list" id="tabList">
        <div :class="searchBarFixed?'tab-list-fix':''">
        <span :class="tabIndex==0?'tab-list-active':''" @click="tabClick(0)">{{$t('zdy.sgzq')}}</span>
        <span :class="tabIndex==1?'tab-list-active':''" @click="tabClick(1)">{{$t('zdy.xmxq')}}</span>
        </div>
      </div>
    <div class="ieo-content" id="ieoright" >
      <div class="ieo-left" v-show="tabIndex==0">
      <div class="ieo-title">{{$t('zdy.sgzq')}}</div>
    <div class="ieo-rbox">
      <div class="ieo-radius">
        <div class="radius">01</div>
        <div class="radius-title">{{$t('zdy.yr')}}</div>
      </div>
      <div class="x-line"></div>
      <div class="ieo-radius">
        <div class="radius">02</div>
        <div class="radius-title">
          <p>{{$t('zdy.sg')}}</p>
          <time>{{detail.start_at}}</time>
        </div>
      </div>
      <div class="x-line"></div>
      <div class="ieo-radius">
        <div class="radius">03</div>
        <div class="radius-title">          
          <p>{{$t('zdy.js')}}</p>
          <time>{{detail.end_at}}</time>
        </div>
      </div>
    </div>
    <div class="ieo-container">
      <div class="ieo-news-title">{{detail.title}}</div>
      <div class="ieo-new-content">{{detail.content}}</div>
    </div>
  </div>
   <div class="ieo-left" v-show="tabIndex==1">
   <div class="ieo-container">
      <div class="ieo-news-title">{{detail.title}}</div>
      <div class="ieo-new-content">{{detail.content}}</div>
    </div>
  </div>
  <div class="ieo-right" >
    <div class='rg-box' >
     <div :class="searchBarRightFixed?'rg-box-fix':''"> 
      <div class="rg-title">{{$t('zdy.rgcz')}}</div>
      
      <div class="rg-num">
        <input type="number" :placeholder="$t('zdy.srrgsl')" v-model="amount" @input="inputAmount">
      </div>
      <div class="rg-currency">
        1 {{detail.currency_name}} = {{detail.price}} {{detail.pay_currency_name}}
        <!-- <select>
          <option value="1">USDT</option>
          <option value="2">ETH</option>
          <option value="3">BTC</option>
          <option value="4">DB</option>
        </select> -->
      </div>
      <div class="rg-ptb">{{$t('zdy.kdh')}}{{detail.pay_currency_name}}：{{compute_price | toFixed8}}</div>
      <div class="rg-submit" v-if="!token" @click="login">{{header.login}}</div>
      <div class="rg-submit" v-if="detail.time_status==1" style="background:#999">{{$t('zdy.wks')}}</div>
      <div class="rg-submit" v-if="detail.time_status==2" @click="submit()">{{$t('zdy.rg')}}</div>      
      <div class="rg-submit" v-if="detail.time_status==3" style="background:#999">{{$t('zdy.yjs')}}</div>
     </div> 
     </div> 
  </div>
  </div>
  </div>
</template>
<script>
import indexHeader from "@/view/indexHeader";
export default {
  name: "ieorgDetail",
  data() {
    return {
      amount:'',
      compute_price:0,
      detail:[],
      searchBarRightFixed:false,
      searchBarFixed:false,
      tabIndex:0,
      token:"",
      nextId:"",
    };
  },
  components: {
    indexHeader
  },
  filters:{
    toFixed8(value){
      var  value=(value*1).toFixed(8);
      return value;
    },
  },
  created() {
    this.nextId=this.$route.query.id;
    this.init(this.nextId);
    this.token=localStorage.getItem('token');
   window.addEventListener('scroll', this.handleScroll)
    document.querySelector('html').setAttribute('style', 'background-color:#fff')
  },
  destroyed(){
    document.querySelector('html').setAttribute('style', '')
     window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {    
    inputAmount(){
      if(this.amount*1<0)return;
      this.compute_price=this.amount*this.detail.price;
    },
    submit(){
        if(this.amount<0){
          layer.msg(this.$t('fat.pnums'));
          return
        }
        layer.load(1);
        this.$http({
          url:"/api/project/order",
          method:"post", 
          data:{
            amount:this.amount,
            project_id:this.detail.id
          }
        }).then(res=>{
          layer.closeAll();
          layer.msg(res.data.message);
          if(res.data.type=="ok"){
            this.amount='';
          }
        }).catch(res=>{
           layer.closeAll();
        })
    },
    login(){
      this.$router.push('/components/login');
    },
    init(){
      let that=this;
      this.$http({
        url:"/api/project/detail?project_id="+this.nextId,
      }).then(res => {
        if (res.data.type == "ok") {
            that.detail=res.data.message.info;
            console.log(that.detail);
        }
      });
    },
    tabClick(i){
      window.scrollTo(0,document.querySelector('.tab-list').offsetTop)
      this.tabIndex=i;
    },
    handleScroll () {
       let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        let offsetTop = document.querySelector('#tabList').offsetTop;
        let offsetTopTwo = document.querySelector('#ieoright').offsetTop;
        console.log(scrollTop);
        console.log(offsetTopTwo);
        
        scrollTop > offsetTop ? this.searchBarFixed = true : this.searchBarFixed = false
        scrollTop > offsetTopTwo ? this.searchBarRightFixed = true : this.searchBarRightFixed = false
    },
  }
};
</script>

<style lang="scss" scoped>
.rg-ptb{
  font-size: 12px;
  margin-top: 10px;
}
.rg-num input{
    width: 100%;
    border: 1px solid #999;
    font-size: 12px;
    padding: 5px;
}
.rg-currency{
  margin: 10px 0;
}
.rg-currency select{
  padding: 5px;
    font-size: 12px;
    width: 100%;
}
.ieo-left{
  width:800px;
}
.rg-box-fix{
position: fixed;
  z-index: 5;
  background: #fff;
  -webkit-box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.1);
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.1);
  width: 360px;
  padding: 15px;
  margin-left: -15px;
  top: 60px;
}
.rg-box{
  background: #fff;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.1);  
  width:360px;
  padding: 15px;
  margin-left: 40px;
}
.rg-title{
  margin: 10px 0;
  font-weight: bold;
  font-size: 16px;
}
.rg-submit:hover{
  opacity: 0.7;
}
.rg-submit{
  margin-top: 20px;
  cursor: pointer;
  line-height: 40px;
    font-size: 16px;
  text-align: center;
      padding: 0px 20px;
    font-size: 14px;
    height: 40px;
  background: linear-gradient(90deg, #f0b90b 0%, #fbda3c 100%);
  box-shadow: 0px 10px 30px 0px rgba(240, 185, 10, 0.3);
  color:#212833;
}
.ieo-new-content{
  margin-top: 40px;
  font-size: 14px;
  word-break: break-all;
}
.ieo-new-content img{
  max-width: 100%;
}
.ieo-news-title{
  font-weight: bold;
  font-size: 16px;
}
.ieo-container{
  margin: 40px 0;
}
.ieo-rbox{
  position: relative;
}
.radius{
      display: block;
    margin: 0 auto;
      width: 44px;
    height: 44px;
    box-shadow: rgba(240, 185, 11, 0.5) 0px 2px 4px 0px;
    line-height: 44px;
    color: rgb(255, 255, 255);
    font-size: 20px;
    text-align: center;
    position: relative;
    font-weight: bold;
    background: linear-gradient(90deg, rgb(251, 218, 60) 0%, rgb(239, 184, 11) 100%);
    border-radius: 100%;
}
.ieo-rbox{
  display: flex;
  flex-direction: row;
}
.ieo-radius{
  text-align: center;
}
.radius-title{
  margin-top: 10px;
  color:#f0ce28;
}
.x-line{
  display: block;
    width: 160px;
    height: 3px;
    position: relative;
    top: 20px;
    left: 20px;
    background: #f0b90b;
    border-radius: 4px;
        margin-right: 40px;
}
.ieo-title{
  margin-bottom: 30px;
  font-size: 16px;
  font-weight: bold;
}
.ieo-content{
  position: relative;
  display: flex;
  flex-direction: row;
  color:#333;
  margin: 30px 0;
  padding: 0px 10%;
}
.tab-list-fix{
  position: fixed;
    top: 0;
    width: 100%;
    background: #fff;
    z-index: 5;
    padding: 10px 10%;
    left: 0;
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.1);
}
.tab-list{
  background: #fff;
  padding: 10px 10%;
  color:#333;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.1);
}
.tab-list-active{
  border-bottom:3px solid #f0ce28;
  color:#f0ce28;
}
.tab-list span:hover{
  color:#f0ce28;
  
}
.tab-list span{
  padding-bottom: 10px;
  cursor: pointer;
  margin-right: 20px;
}
.bg{
  display: flex;
  flex-direction: row;
  width:100%;
  padding: 50px  10%;
  background: #000;
}
.bg-right{
  width:918px;
}
.bg-title{
  padding-bottom: 15px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
}
.bg-title h1{
  font-size: 16px;
  margin-bottom: 20px;
}
.bg-title span{
  color:#999;
  font-size: 12px;
}
.bg-left{
    margin-right: 30px;
    width: 282px;
    height: 198px;
}
.bg-fa article em{
  font-size: 14px;
}
.bg-fa article span{
  font-size: 13px;
  color:#999;
  margin-bottom: 7px;
}
.bg-fa article{
  width: 50%;
  display: flex;
  flex-direction: column;
}
.bg-btm{
  margin-top: 15px;
}
.bg-btm a:hover{
  color:#f0ce28
}
.bg-btm a{
  color:#999;
  font-size:14px;
  cursor: pointer;
  margin-right: 10px;
}
.bg-fa{
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
  display: flex;
  flex-direction: row;
  margin-top: 20px;
}
.bg-left img{
  width:100%;
  height:100%
}
.wt150 {
  width: 150px;
}
.box .account {
  width: 1200px;
  margin: 0 auto 82px;
  margin-top: 30px;
}
.topcontent {
  padding: 22px 30px;
  margin-bottom: 20px;
  // background-color: #1a2330;
  border-radius: 5px;
}
.account_title {
  padding: 15px 20px;
}
select {
  background-color: transparent;
  padding: 10px;
  // color: #c7cce6;
  font-size: 18px;
  border-radius: 3px;
  // border: 1px solid #4e5b85;
}
select.ft14 {
  font-size: 14px;
}
select > option {
  padding: 10px 0;
  background-color: transparent;
}
input {
  padding: 10px;
  // border: 1px solid #4e5b85;
  font-size: 18px;
  // color: #c7cce6;
  border-radius: 3px;
  background-color: transparent;
  outline: none;
}
.add {
  // text-align: right;
  margin-top: 20px;
}
.add .baseBtn {
  width: 100%;
  margin-top: 60px;
}
.btn {
  width: 150px;
  height: 100%;
  line-height: 42px;
  border-radius: 3px;
  background: #357ce1;
  color: #fff;
  margin-left: 20px;
}
.pb10 {
  padding: 10px;
}
.mb10 {
  margin-bottom: 10px;
}
.ptb10{
  padding-top: 10px;
  padding-bottom: 10px;
}
.plr10{
  padding-left: 10px;
  padding-right: 10px;
}
</style>





// WEBPACK FOOTER //
// src/view/ieorgDetail.vue